import React, { Component } from 'react';

import SectionList from './Section/SectionList';

class SectionRecruit extends Component {

  render() {

    const { $$data, barOffset, width } = this.props;

    const align = 'left';

    const listProps = {id: 'candidat', data: $$data, barOffset, align, className: 'SectionRecruit', title: 'Côté Candidat', titleIcon: 'recruit', titleColor: '#fff', titleSize: width};
    return (
      <SectionList barColor={'#fff'} {...listProps} style={this.props.style || {}} />
    );
  }
}

export default SectionRecruit;



// WEBPACK FOOTER //
// ./src/components/Home/SectionRecruit.jsx